// Dictionary to extend the current VeeValidate errors.

export const dict = {
    custom: {
        accepted_terms: {
            required: 'You must accept the terms and conditions.'
        },
        home_house_name: {
            required: 'Either a house name or number is required.'
        },
        home_house_number: {
            required: 'Either a house name or number is required.'
        },
        billing_house_name: {
            required: 'Either a house name or number is required.'
        },
        billing_house_number: {
            required: 'Either a house name or number is required.'
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/setup/customErrors.js